var map = {
	"./instruction-1-en.webp": 3661,
	"./instruction-1-ru.webp": 1319,
	"./instruction-1-ua.webp": 5236,
	"./instruction-2-en.webp": 5602,
	"./instruction-2-ru.webp": 4580,
	"./instruction-2-ua.webp": 5959,
	"./instruction-3-en.webp": 9591,
	"./instruction-3-ru.webp": 9985,
	"./instruction-3-ua.webp": 8626,
	"./instruction-4-en.webp": 884,
	"./instruction-4-ru.webp": 1062,
	"./instruction-4-ua.webp": 861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7502;